import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000/api";
// const API_BASE_URL = 'http://192.168.100.140:5000/api'
// const API_BASE_URL =
//   process.env.REACT_APP_BACKEND_URL || "https://77.37.63.90:5000/api";

// const API_BASE_URL =
//   process.env.REACT_APP_BACKEND_URL || 'https://alnoordevelopers.com/api'
// const API_BASE_URL =
//   process.env.REACT_APP_BACKEND_URL || 'https://alnoordevelopers.com/api:5000'

// const API_BASE_URL =
//   process.env.REACT_APP_BACKEND_URL || "https://alnoordevelopers.com:5001/api";
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Client-side request timing
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Mark request start
    config.metadata = { startTime: performance.now() };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    const start = response.config?.metadata?.startTime;
    if (typeof start === "number") {
      const durationMs = performance.now() - start;
      const url = `${response.config.method?.toUpperCase()} ${response.config.url
        }`;
      const serverTiming = response.headers?.["server-timing"];
      // eslint-disable-next-line no-console
      // console.log(
      //   `[NET] ${url} -> ${response.status} in ${durationMs.toFixed(0)}ms${
      //     serverTiming ? ` | server-timing: ${serverTiming}` : ''
      //   }`
      // )
    }
    return response;
  },
  (error) => {
    const cfg = error.config || {};
    const start = cfg.metadata?.startTime;
    if (typeof start === "number") {
      const durationMs = performance.now() - start;
      const url = `${cfg.method?.toUpperCase()} ${cfg.url}`;
      const status = error.response?.status || "ERR";
      const serverTiming = error.response?.headers?.["server-timing"];
      // eslint-disable-next-line no-console
      console.warn(
        `[NET] ${url} -> ${status} in ${durationMs.toFixed(0)}ms${serverTiming ? ` | server-timing: ${serverTiming}` : ""
        }`
      );
    }
    return Promise.reject(error);
  }
);

// Authentication API
export const login = async (credentials) => {
  const response = await api.post("/auth/login", credentials);
  return response.data;
};

export const register = async (formData) => {
  try {
    const response = await api.post("/auth/register", formData);
    return response.data;
  } catch (error) {
    console.error("Error during registration:");

    // Log the full error
    console.error("Full error:", error);

    // Log the response data if available
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }

    throw error;
  }
};

export const verifyPassword = async ({ userId }) => {
  try {
    const response = await api.post("/auth/verify-password", { userId });
    return response.data;
  } catch (error) {
    console.error("Error verifying password:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};
export const resetPassword = async ({ userId, newPassword }) => {
  try {
    const response = await api.post("/auth/reset-password", {
      userId,
      newPassword,
    });
    return response.data;
  } catch (error) {
    console.error("Error resetting password:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Admin API functions
export const getAdmin = async (adminId) => {
  try {
    const response = await api.get(`/auth/admin/${adminId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const updateAdmin = async (adminId, updates) => {
  try {
    const response = await api.put(`/auth/admin/${adminId}`, updates);
    return response.data;
  } catch (error) {
    console.error("Error updating admin:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const logout = async () => {
  const token = sessionStorage.getItem("token");
  const response = await api.post(
    "/auth/logout",
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const refreshToken = async () => {
  const response = await api.post("/auth/refresh-token");
  return response.data;
};

export const updateUserStatus = async (userId, status) => {
  try {
    const response = await api.patch(`/users/${userId}/status`, { status });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// User API calls
export const getAllUsers = async () => {
  try {
    const response = await api.get("/users");

    return response.data;
  } catch (error) {
    console.error("Error in getAllUsers API:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateUser = async (userId, updatedData) => {
  try {
    const response = await api.put(`/users/${userId}`, updatedData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
export const deleteUser = async (userId) => {
  try {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const changeUserStatus = async (userId, status) => {
  try {
    const response = await api.patch(`/users/${userId}/status`, { status });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getUsersByRole = async (role) => {
  try {
    const response = await api.get(`/users/role/${role}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateUserSocieties = async (userId, societies) => {
  try {
    const response = await api.patch(`/users/${userId}/societies`, {
      societies,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await api.get("/auth/current-user");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCurrentUser1 = async () => {
  try {
    const response = await api.get("/users/me");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Customer API calls
export const getCustomerById = async () => {
  try {
    const response = await api.get("/customer/me");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateCustomer = async (customerId, updatedData) => {
  try {
    const response = await api.put(
      `/customer/customer/${customerId}`,
      updatedData
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateOwnInfo = async (updatedData) => {
  try {
    const response = await api.put("/customer/me", updatedData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCustomerPlots = async (customerId) => {
  try {
    const response = await api.get(`customer/${customerId}/plots`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCustomerPayments = async () => {
  try {
    const response = await api.get("/customer/me/payments");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getCustomerInteractions = async () => {
  try {
    const response = await api.get("/customer/me/interactions");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Investor API calls
export const getAllInvestors = async () => {
  try {
    const response = await api.get("/investors");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getInvestorById = async (investorId) => {
  try {
    const response = await api.get(`/investors/${investorId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateInvestor = async (investorId, updatedData) => {
  try {
    const response = await api.put(`/investors/${investorId}`, updatedData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const changeInvestorStatus = async (investorId, status) => {
  try {
    const response = await api.patch(`/investors/${investorId}/status`, {
      status,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteInvestor = async (investorId) => {
  try {
    const response = await api.delete(`/investors/${investorId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getInvestorsBySociety = async (societyId) => {
  try {
    const response = await api.get(`/investors/society/${societyId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Employee API calls
export const getAllEmployees = async () => {
  try {
    const response = await api.get("/employees");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getEmployeeById = async (employeeId) => {
  try {
    const response = await api.get(`/employees/${employeeId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateEmployee = async (employeeId, updatedData) => {
  try {
    const response = await api.put(`/employees/${employeeId}`, updatedData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const changeEmployeeStatus = async (employeeId, status) => {
  try {
    const response = await api.patch(`/employees/${employeeId}/status`, {
      status,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteEmployee = async (employeeId) => {
  try {
    const response = await api.delete(`/employees/${employeeId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getEmployeesBySociety = async (societyId) => {
  try {
    const response = await api.get(`/employees/society/${societyId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

/// Society API

// Create a new society (Admin only)
export const createSociety = async (societyData) => {
  const response = await api.post("/societies", societyData);
  return response.data;
};

export const getAllSocieties = async () => {
  const response = await api.get("/societies");
  return response.data.societies;
};

export const getSocietyById = async (societyId) => {
  const response = await api.get(`/societies/${societyId}`);
  return response.data;
};

export const getSocietyByName = async (societyName) => {
  const response = await api.get(`/societies/name/${societyName}`);
  return response.data;
};

export const updateSociety = async (societyId, updatedData) => {
  try {
    // Make sure societyId is defined before making the request
    if (!societyId) {
      throw new Error("Society ID is undefined");
    }
    // console.log('Updating society with ID:', societyId) // Add logging
    const response = await api.put(`/societies/${societyId}`, updatedData);
    return response.data;
  } catch (error) {
    console.error("Update society error:", error);
    throw error; // Pass the original error for better debugging
  }
};

// Update society pricing configuration
export const updateSocietyPricing = async (societyId, plotPricing) => {
  try {
    if (!societyId) {
      throw new Error("Society ID is undefined");
    }
    // console.log('Updating society pricing with ID:', societyId)
    const response = await api.put(`/societies/${societyId}/pricing`, {
      plot_pricing: plotPricing,
    });
    return response.data;
  } catch (error) {
    console.error("Update society pricing error:", error);
    throw error;
  }
};

// Delete a society by ID (Admin only)
export const deleteSociety = async (societyId) => {
  const response = await api.delete(`/societies/${societyId}`);
  return response.data;
};

// Add a plot to a society (Admin, Manager)
export const addPlotToSociety = async (plotData) => {
  const response = await api.post("/societies/add-plot", plotData);
  return response.data;
};

// Remove a plot from a society (Admin, Manager)

// Edit a plot within a society
export const editPlotFromSociety = async (societyId, plotId, plotData) => {
  const response = await api.put(
    `/societies/edit-plot/${societyId}/plot/${plotId}`,
    plotData
  );
  return response.data;
};

// Remove a plot from a society
export const removePlotFromSociety = async (societyId, plotId) => {
  try {
    const response = await api.delete(
      `/societies/remove-plot/${societyId}/plot/${plotId}`
    );
    return response.data; // Ensure the API is returning the correct response
  } catch (error) {
    console.error("Error deleting plot:", error);
    throw error; // Rethrow the error if any
  }
};

// Add a user to a society (Admin only)
export const addUserToSociety = async (userData) => {
  const response = await api.post("/societies/add-user", userData);
  return response.data;
};

export const fetchPlotsAPI = async (societyId) => {
  const response = await api.get(`/societies/${societyId}/plots`);
  return response.data;
};

// Update a specific plot's data
export const updatePlotAPI = async (plotData) => {
  const { plotId, ...updatedData } = plotData;
  const response = await api.put(`/plots/${plotId}`, updatedData);
  return response.data;
};
// Remove a user from a society (Admin only)
export const removeUserFromSociety = async (society_id, user_id) => {
  const response = await api.delete(
    `/societies/remove-user/${society_id}/${user_id}`
  );
  return response.data;
};

// Booking API

export const createBooking = async (bookingData) => {
  try {
    const response = await api.post("/booking/create", bookingData); // Fixed path
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getBookingById = async (bookingId) => {
  try {
    const response = await api.get(`/booking/bookings/${bookingId}`); // Fixed path
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getAllBookings = async () => {
  try {
    const response = await api.get("/booking/bookings");
    // console.log('Fetched bookings:', response.data)
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateBookingStatus = async (bookingId, status) => {
  try {
    const response = await api.put(`/booking/bookings/${bookingId}/status`, {
      status,
    }); // Fixed path
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const updateBooking = async (bookingId, bookingData) => {
  try {
    const response = await api.put(
      `/booking/bookings/${bookingId}`,
      bookingData
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const canEditBooking = async (bookingId) => {
  try {
    const response = await api.get(`/booking/bookings/${bookingId}/can-edit`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteBooking = async (bookingId) => {
  try {
    const response = await api.delete(`/booking/bookings/${bookingId}`); // Fixed path
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Installment API

export const payInstallment = async (paymentData) => {
  try {
    const response = await api.post("/booking/installments/pay", paymentData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getInstallmentsForUser = async (customerId) => {
  try {
    const response = await api.get(`/booking/installments/user/${customerId}`);
    // console.log(response)
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// export const getPaidInstallmentsForUser = async (customerId, plotId) => {
//   try {
//     const response = await api.get(
//       `/booking/installments/user/${customerId}/plot/${plotId}/paid`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data : error;
//   }
// };

// REMOVE OR MODIFY - Don't fetch by customer_id alone
export const getPaidInstallmentsForUser = async (customerId, plotId) => {
  try {
    console.log('DEBUG: getPaidInstallmentsForUser API called with plotId:', plotId);
    // Change endpoint to fetch by plot_id instead of customer_id
    const response = await api.get(
      `/booking/installments/plot/${plotId}/paid`  // CHANGED: removed customer_id from URL
    );
    console.log('DEBUG: getPaidInstallmentsForUser API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('DEBUG: getPaidInstallmentsForUser API error:', error);
    throw error.response ? error.response.data : error;
  }
};

// DEPRECATED: SECURITY VULNERABILITY - Leaks previous owner data
// Use getActiveInstallmentsByBooking or getResellInstallmentsByBooking instead
export const getInstallmentsByPlotId = async (plotId) => {
  try {
    const response = await api.get(`/booking/installments/plot/${plotId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// DEPRECATED: SECURITY VULNERABILITY - Leaks previous owner data
// Use getActiveInstallmentsByBooking or getResellInstallmentsByBooking instead
export const getInstallmentsByPlotIdAndStatus = async (plotId, status) => {
  try {
    const response = await api.get(
      `/booking/installments/plot/${plotId}/status/${status}`
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Get bookings by customer ID
export const getBookingsByCustomer = async (customerId) => {
  try {
    // console.log(customerId)
    const response = await api.get(`/booking/bookings/customer/${customerId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Get installments by booking ID
export const getInstallmentsByBooking = async (bookingId) => {
  try {
    const response = await api.get(
      `/booking/installments/booking/${bookingId}`
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// PHASE-6: NEW BOOKING-AWARE APIs (SECURITY FIXES)
// Get active installments for a booking (cancel-safe)
export const getActiveInstallmentsByBooking = async (bookingId) => {
  try {
    const response = await api.get(
      `/booking/installments/booking/${bookingId}/active`
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Get split view for resold plots
export const getResellInstallmentsByBooking = async (bookingId) => {
  try {
    const response = await api.get(
      `/booking/installments/booking/${bookingId}/resell`
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const checkOverdueInstallments = async (plotId) => {
  try {
    const endpoint = `/booking/installments/check-overdue${plotId ? `?plot_id=${plotId}` : ""
      }`;
    const response = await api.get(endpoint);
    return response.data.overdueInstallments; // Return only the required data
  } catch (error) {
    // Enhance error handling for consistency
    const errorMessage =
      error.response?.data?.message || "Failed to fetch overdue installments";
    console.error("Error fetching overdue installments:", errorMessage);
    throw new Error(errorMessage); // Throw a consistent error message
  }
};

export const updateInstallmentStatus = async (installmentId, data) => {
  try {
    const response = await api.put(`/booking/installments/update`, {
      installment_id: installmentId,
      ...data,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Financial

export const createTransaction = async (transactionData) => {
  try {
    const response = await api.post("/financial/transactions", transactionData);
    return response.data;
  } catch (error) {
    console.error("Error creating transaction:", error);
    throw error;
  }
};

export const getAllTransactions = async (
  page,
  limit,
  direction,
  societyId,
  description,
  startDate,
  endDate,
  sortOrder,
  transactionType
) => {
  try {
    const params = {
      transaction_direction: direction,
      society_id: societyId,
      description,
      sortOrder,
    };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (transactionType) params.transactionType = transactionType;
    if (!startDate && !endDate) {
      params.page = page;
      params.limit = limit;
    }
    const response = await api.get("/financial/transactions", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};

export const getTransactionById = async (id) => {
  try {
    const response = await api.get(`/financial/transactions/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching transaction:", error);
    throw error;
  }
};

export const updateTransaction = async (id, transactionData) => {
  try {
    // console.log('API Payload:', transactionData)
    const response = await api.put(`/financial/transactions/${id}`, transactionData);
    return response.data;
  } catch (error) {
    console.error("Error updating transaction:", error);
    throw error;
  }
};

export const deleteTransaction = async (id) => {
  try {
    const response = await api.delete(`/financial/transactions/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting transaction:", error);
    throw error;
  }
};

// General Transaction
// Function to create a new transaction
export const createGeneralTransaction = async (transactionData) => {
  try {
    const response = await api.post("/generalTransaction", transactionData);
    // console.log('Transaction created:', response.data) // Add logging to check the response
    return response.data;
  } catch (error) {
    console.error("Error creating transaction:", error);
    throw error;
  }
};

/// Function to fetch all transactions with optional filters
export const fetchGeneralTransactions = async (filters = {}) => {
  try {
    const response = await api.get("/generalTransaction", { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    throw error;
  }
};

// Function to update a specific transaction by ID
export const updateGeneralTransaction = async (transactionId, updatedData) => {
  try {
    const response = await api.put(
      `/generalTransaction/${transactionId}`,
      updatedData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating transaction:", error);
    throw error;
  }
};

// Function to delete a specific transaction by ID
export const deleteGeneralTransaction = async (transactionId) => {
  try {
    // Construct the correct URL and pass authentication headers if necessary
    const response = await api.delete(`/generalTransaction/${transactionId}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
      },
    });

    return response.data; // Return the response data
  } catch (error) {
    console.error("Error deleting transaction:", error);
    throw error; // Ensure the error is thrown so it can be handled elsewhere
  }
};

// Function to fetch the transaction summary (total income, expense, and balance)
export const fetchGeneralTransactionSummary = async () => {
  try {
    const response = await api.get("/generalTransaction/summary"); // Using 'api' to ensure proper authorization
    return response.data;
  } catch (error) {
    console.error("Error fetching transaction summary:", error);
    throw error;
  }
};

// Resell API

// Fetch all resells
export const fetchAllResells = async () => {
  try {
    const response = await api.get("/resell/resells");
    return response.data;
  } catch (error) {
    console.error("Error fetching resells:", error);
    throw error;
  }
};

// Fetch resell by ID
export const fetchResellById = async (resellId) => {
  try {
    const response = await api.get(`/resell/resells/${resellId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching resell by ID:", error);
    throw error;
  }
};

// Create a new resell
export const createResell = async (resellData) => {
  try {
    const response = await api.post("/resell/resells", resellData);
    return response.data;
  } catch (error) {
    console.error("Error creating resell:", error);
    throw error;
  }
};

// Update a resell by ID
export const updateResell = async (resellId, resellData) => {
  try {
    const response = await api.put(`/resell/resells/${resellId}`, resellData);
    return response.data;
  } catch (error) {
    console.error("Error updating resell:", error);
    throw error;
  }
};

// Delete a resell by ID (soft delete)
export const deleteResell = async (resellId) => {
  try {
    const response = await api.delete(`/resell/resells/${resellId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting resell:", error);
    throw error;
  }
};

// Aggregation

export const fetchAggregatedData = async (societyId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.range) queryParams.append('range', params.range);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    const queryString = queryParams.toString();
    const url = queryString
      ? `/dashboard/aggregated-data/${societyId}?${queryString}`
      : `/dashboard/aggregated-data/${societyId}`;

    const response = await api.get(url);
    return response.data.data; // Extract only the data key
  } catch (error) {
    console.error("Error fetching aggregated data:", error);
    throw error;
  }
};

// P0: Dashboard endpoints
export const fetchOverdueSummary = async (societyId) => {
  try {
    const response = await api.get(`/dashboard/overdue-summary/${societyId}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching overdue summary:", error);
    throw error;
  }
};

export const fetchMonthlyAgingReport = async (societyId, month = null) => {
  try {
    const url = month
      ? `/dashboard/aging-report/${societyId}?month=${month}`
      : `/dashboard/aging-report/${societyId}`;
    const response = await api.get(url);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching aging report:", error);
    throw error;
  }
};

// Fetch income breakdown (installments, bookings, initial payments)
export const fetchIncomeBreakdown = async (societyId) => {
  try {
    // For now, return null to use fallback calculation
    // This can be implemented when backend API is ready
    return null;
  } catch (error) {
    console.error('Error fetching income breakdown:', error);
    throw error;
  }
};

export const fetchMonthlyCollectionRate = async (societyId, month = null) => {
  try {
    const url = month
      ? `/dashboard/collection-rate/${societyId}?month=${month}`
      : `/dashboard/collection-rate/${societyId}`;
    const response = await api.get(url);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching collection rate:", error);
    throw error;
  }
};

export const fetchRecentActivity = async (societyId, limit = 10) => {
  try {
    const response = await api.get(`/dashboard/recent-activity/${societyId}`, { params: { limit } });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching recent activity:", error);
    throw error;
  }
};

export const fetchUpcomingDueDates = async (societyId, days = 30) => {
  try {
    const response = await api.get(`/dashboard/upcoming-due-dates/${societyId}`, { params: { days } });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching upcoming due dates:", error);
    throw error;
  }
};

// P1: Export Reports (PDF/Excel)
export const exportOverdueReport = async (societyId, format = 'pdf') => {
  try {
    // Fix: Use correct route format (pdf or excel in path, not query param)
    const route = format === 'excel' ? `/reports/overdue/${societyId}/excel` : `/reports/overdue/${societyId}/pdf`;
    const contentType = format === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';
    const response = await api.get(route, {
      responseType: 'blob',
      validateStatus: function (status) {
        return status < 500; // Don't throw for 4xx errors, we'll handle them
      }
    });

    // Check if response is actually a blob or an error JSON
    if (response.headers['content-type']?.includes('application/json')) {
      // Error response came as JSON
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || 'Failed to export overdue report');
    }

    // Verify it's a valid blob
    if (!response.data || response.data.size === 0) {
      throw new Error('Empty file received');
    }

    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement('a');
    link.href = url;
    const filename = `Overdue_Report_${new Date().toISOString().slice(0, 10)}.${format === 'excel' ? 'xlsx' : 'pdf'}`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (error) {
    console.error("Error exporting overdue report:", error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to export overdue report';
    throw new Error(errorMessage);
  }
};

export const exportMonthlyCollectionReport = async (societyId, format = 'pdf') => {
  try {
    // Fix: Use correct route - collection route doesn't have format in path, check controller
    const response = await api.get(`/reports/collection/${societyId}?format=${format}`, {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = `Monthly_Collection_Report_${new Date().toISOString().slice(0, 10)}.${format === 'excel' ? 'xlsx' : 'pdf'}`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (error) {
    console.error("Error exporting monthly collection report:", error);
    throw error;
  }
};

export const exportAgingReport = async (societyId, format = 'pdf') => {
  try {
    // Fix: Use correct route - aging route doesn't have format in path, check controller
    const response = await api.get(`/reports/aging/${societyId}?format=${format}`, {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = `Aging_Report_${new Date().toISOString().slice(0, 10)}.${format === 'excel' ? 'xlsx' : 'pdf'}`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (error) {
    console.error("Error exporting aging report:", error);
    throw error;
  }
};

// P0: Customer dashboard endpoints
export const fetchCustomerDashboardSummary = async () => {
  try {
    const response = await api.get("/customer/dashboard-summary");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching customer dashboard summary:", error);
    throw error;
  }
};

export const fetchUpcomingPayments = async () => {
  try {
    const response = await api.get("/customer/upcoming-payments");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching upcoming payments:", error);
    throw error;
  }
};

export const fetchOverdueAmount = async () => {
  try {
    const response = await api.get("/customer/overdue-amount");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching overdue amount:", error);
    throw error;
  }
};

export const fetchPaymentSchedule = async () => {
  try {
    const response = await api.get("/customer/payment-schedule");
    return response.data.data;
  } catch (error) {
    console.error("Error fetching payment schedule:", error);
    throw error;
  }
};

export const downloadReceiptPDF = async (installmentId, receiptNo = null) => {
  try {
    const response = await api.get(`/customer/receipt/${installmentId}/pdf`, {
      responseType: 'blob',
      validateStatus: function (status) {
        return status < 500; // Don't throw for 4xx errors, we'll handle them
      },
      timeout: 30000 // 30 second timeout
    });

    // Check HTTP status
    if (response.status >= 400) {
      // Try to parse error message from blob
      try {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || `Server error: ${response.status}`);
      } catch (parseError) {
        throw new Error(`Failed to download receipt: HTTP ${response.status}`);
      }
    }

    // Check if response is actually a blob (PDF) or an error JSON
    const contentType = response.headers['content-type'] || '';
    if (contentType.includes('application/json')) {
      // Error response came as JSON
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || 'Failed to download receipt');
    }

    // Verify it's a PDF blob
    if (!response.data || response.data.size === 0) {
      throw new Error('Empty file received from server');
    }

    // Verify it's actually a PDF (check first few bytes)
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const arrayBuffer = await blob.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    // PDF files start with %PDF
    if (uint8Array.length < 4 ||
      String.fromCharCode(uint8Array[0], uint8Array[1], uint8Array[2], uint8Array[3]) !== '%PDF') {
      // Might be JSON error
      const text = new TextDecoder().decode(arrayBuffer);
      try {
        const errorData = JSON.parse(text);
        throw new Error(errorData.message || 'Invalid PDF file received');
      } catch {
        throw new Error('Invalid PDF file received from server');
      }
    }

    // Create a more reliable download mechanism
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.style.display = 'none';
    link.setAttribute('download', receiptNo ? `receipt-${receiptNo}.pdf` : `receipt-${installmentId}.pdf`);
    document.body.appendChild(link);

    // Use a small delay before clicking to ensure browser registers the link
    await new Promise(resolve => setTimeout(resolve, 100));

    link.click();

    // Wait a bit before cleanup to ensure download starts
    await new Promise(resolve => setTimeout(resolve, 300));

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    console.error("Error downloading receipt:", error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to download receipt';
    throw new Error(errorMessage);
  }
};

export const fetchCustomerDocuments = async (bookingId) => {
  try {
    const response = await api.get(`/customer/documents/${bookingId}`);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching customer documents:", error);
    throw error;
  }
};

export const downloadDocumentPDF = async (bookingId, documentType) => {
  try {
    const response = await api.get(`/customer/documents/${bookingId}/${documentType}/pdf`, {
      responseType: 'blob',
      validateStatus: function (status) {
        return status < 500; // Don't throw for 4xx errors, we'll handle them
      }
    });

    // Check if response is actually a blob (PDF) or an error JSON
    if (response.headers['content-type']?.includes('application/json')) {
      // Error response came as JSON
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || `Failed to download ${documentType} document`);
    }

    // Verify it's a PDF blob
    if (!response.data || response.data.size === 0) {
      throw new Error('Empty file received');
    }

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${documentType}_${bookingId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (error) {
    console.error(`Error downloading ${documentType} document:`, error);
    const errorMessage = error.response?.data?.message || error.message || `Failed to download ${documentType} document`;
    throw new Error(errorMessage);
  }
};

// P1: Customer Document Upload
export const uploadCustomerDocuments = async (bookingId, files) => {
  try {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('documents', file);
    });
    const response = await api.post(`/customer/me/documents/upload/${bookingId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading customer documents:", error);
    throw error;
  }
};

// Transfer a plot
export const transferPlot = async (plotData) => {
  const response = await api.post("/transferplot/", plotData, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Ensure the authorization token is passed
    },
  });
  return response.data;
};

// Fetch all transfer plots
export const fetchTransferPlots = async (query = {}) => {
  const queryString = new URLSearchParams(query).toString();
  const response = await api.get(`/transferplot/?${queryString}`, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
  return response.data;
};

// Resell Slip Download
export const downloadResellSlipPDF = async (resellId) => {
  try {
    const response = await api.get(`/resell/resells/${resellId}/slip`, {
      responseType: 'blob',
    });

    if (response.headers['content-type']?.includes('application/json')) {
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || 'Failed to download resell slip');
    }

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `resell_agreement_${resellId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return { success: true };
  } catch (error) {
    console.error("Error downloading resell slip:", error);
    throw error;
  }
};

// Notification APIs

// Create a new notification
export const createNotification = async (notificationData) => {
  try {
    const response = await api.post("/notifications", notificationData);
    return response.data;
  } catch (error) {
    console.error("Error creating notification:", error);
    throw error;
  }
};

// Fetch notifications for a specific user
export const fetchUserNotifications = async (userId) => {
  try {
    const response = await api.get(`/notifications/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user notifications:", error);
    throw error;
  }
};

// Fetch admin notifications
export const fetchAdminNotifications = async () => {
  try {
    const response = await api.get(`/notifications/admin`);
    return response.data;
  } catch (error) {
    console.error("Error fetching admin notifications:", error);
    throw error;
  }
};

// Mark a notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.patch(`/notifications/${notificationId}/read`);
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};

// Delete a notification
export const deleteNotification = async (notificationId) => {
  try {
    const response = await api.delete(`/notifications/${notificationId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting notification:", error);
    throw error;
  }
};

// Salary API calls

// Pay salary to an employee
export const paySalary = async (employeeId) => {
  try {
    const response = await api.post(`/salary/pay-salary/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error paying salary:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const grantAdvance = async (employeeId, advanceData) => {
  try {
    const response = await api.post(
      `/salary/grant-advance/${employeeId}`,
      advanceData
    );
    return response.data;
  } catch (error) {
    console.error("Error granting advance:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getAdvanceGrantHistory = async (employeeId) => {
  try {
    const response = await api.get(`/salary/advance-history/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching advance grant history:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Generate salary slip for an employee
export const generateSalarySlip = async (employeeId) => {
  try {
    const response = await api.get(`/salary/generate-slip/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error generating salary slip:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get payment history of an employee
export const getPaymentHistory = async (employeeId) => {
  try {
    const response = await api.get(`/salary/payment-history/${employeeId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payment history:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Update salary details of an employee
export const updateSalaryDetails = async (employeeId, salaryDetails) => {
  try {
    const response = await api.put(
      `/salary/update-salary/${employeeId}`,
      salaryDetails
    );
    return response.data;
  } catch (error) {
    console.error("Error updating salary details:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Scholarship API
export const createScholarship = async (scholarshipData) => {
  const response = await api.post("/scholarship/scholarships", scholarshipData);
  return response.data;
};

export const getAllScholarships = async () => {
  const response = await api.get("/scholarship/scholarships");
  return response.data;
};

export const updateScholarshipStatus = async (id, statusUpdate) => {
  const response = await api.put(
    `/scholarship/scholarships/${id}`,
    statusUpdate
  );
  return response.data;
};

export const deleteScholarship = async (id) => {
  const response = await api.delete(`/scholarship/scholarships/${id}`);
  return response.data;
};
export const getAllScholarshipsByStatus = async (status) => {
  const response = await api.get(`/scholarship/scholarships/status`, {
    params: { status },
  });
  return response.data;
};

// Message API
// export const sendMessageWithAttachments = async data => {
//   const response = await api.post('/messages/attachments', data)
//   return response.data
// }

// export const sendCapturedImage = async data => {
//   const response = await api.post('/messages/capture', data)
//   return response.data
// }

// export const getConversation = async userId => {
//   const response = await api.get(`/messages/conversation/${userId}`)
//   return response.data
// }

// export const getAllMessages = async () => {
//   const response = await api.get('/messages/all_messages')
//   return response.data
// }

export const fetchEntriesAPI = async (khataBy) => {
  try {
    const response = await api.get(`/khata/${khataBy}`);
    return response.data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const createEntryAPI = async (entry) => {
  try {
    const response = await api.post(`/khata`, entry);
    return response.data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const deleteEntryAPI = async (id) => {
  try {
    await api.delete(`/khata/${id}`);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateEntryAPI = async (id, updatedEntry) => {
  try {
    const response = await api.put(`/khata/${id}`, updatedEntry);
    return response.data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchAllAccountsAPI = async () => {
  try {
    const response = await api.get("/khata/accounts");
    return response.data.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Cancel Plot API functions

export const cancelPlot = async (plotData) => {
  try {
    const response = await api.post("/cancel-plot/cancel", plotData);
    return response.data;
  } catch (error) {
    console.error("Error canceling plot:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const processRefund = async (refundData) => {
  try {
    const response = await api.post("/cancel-plot/refund", refundData);
    return response.data;
  } catch (error) {
    console.error("Error processing refund:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getCanceledPlots = async (filters = {}) => {
  try {
    const response = await api.get("/cancel-plot/canceled", {
      params: filters,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching canceled plots:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getRefundInstallments = async (cancelPlotId) => {
  try {
    const response = await api.get(
      `/cancel-plot/refund-installments/${cancelPlotId}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching refund installments:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

export const updateRefundInstallment = async (installmentId, updateData) => {
  try {
    const response = await api.patch(
      `/cancel-plot/refund-installments/${installmentId}`,
      updateData
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating refund installment:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

export const getCancelPlotDetails = async (cancelPlotId) => {
  try {
    const response = await api.get(`/cancel-plot/${cancelPlotId}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching cancel plot details:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Lead API Functions
export const createLead = async (leadData) => {
  try {
    const response = await api.post("/leads", leadData);
    return response.data;
  } catch (error) {
    console.error("Error creating lead:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getAllLeads = async () => {
  try {
    const response = await api.get("/leads");
    return response.data;
  } catch (error) {
    console.error("Error fetching leads:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const createLeadFollowUp = async (followUpData) => {
  const response = await api.post("/leads/followup", followUpData);
  return response.data;
};

export const getLeadFollowUps = async (leadId) => {
  const response = await api.get(`/leads/followup/${leadId}`);
  return response.data;
};

export const getPendingFollowUps = async () => {
  const response = await api.get("/leads/pending-followups");
  return response.data;
};

export const getAdminLeadStats = async () => {
  const response = await api.get("/leads/admin/stats");
  return response.data;
};

export const getLeadSourceStats = async () => {
  try {
    const response = await api.get("/leads/stats/sources");
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getLeadById = async (leadId) => {
  try {
    const response = await api.get(`/leads/${leadId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching lead ${leadId}:`, error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const updateLead = async (leadId, updateData) => {
  try {
    const response = await api.put(`/leads/${leadId}`, updateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating lead ${leadId}:`, error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const deleteLead = async (leadId) => {
  try {
    const response = await api.delete(`/leads/${leadId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting lead ${leadId}:`, error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Permissions API

// Get current user's permissions (e.g. for sidebar)
export const getUserPermissions = async (userId = "me") => {
  try {
    const response = await api.get(`/permission/user/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user permissions:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Admin: Get all users with their permissions
export const getAllUsersPermissions = async () => {
  try {
    const response = await api.get("/permission/admin/users");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching all users' permissions:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Admin: Get available menu items
export const getAvailableMenuItems = async () => {
  try {
    const response = await api.get("/permission/admin/menu-items");
    return response.data;
  } catch (error) {
    console.error("Error fetching menu items:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Admin: Update a user's permissions
export const updateUserPermissions = async (userId, menuPermissions) => {
  try {
    const response = await api.put(`/permission/admin/user/${userId}`, {
      menuPermissions,
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error updating permissions for user ${userId}:`,
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Admin: Reset a user's permissions to default
export const resetUserPermissions = async (userId) => {
  try {
    const response = await api.post(`/permission/admin/user/${userId}/reset`);
    return response.data;
  } catch (error) {
    console.error(
      `Error resetting permissions for user ${userId}:`,
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Admin: Bulk update permissions
export const bulkUpdatePermissions = async (userIds, menuPermissions) => {
  try {
    const response = await api.post("/permission/admin/bulk-update", {
      userIds,
      menuPermissions,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error performing bulk permission update:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// =============================================
// MESSAGE API ROUTES
// =============================================

// Send a message
export const sendMessage = async (messageData) => {
  try {
    // If messageData is already FormData, send it directly
    if (messageData instanceof FormData) {
      // console.log('📤 Sending FormData directly')
      const response = await api.post("/messages/send", messageData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    }

    // For regular text messages, create FormData
    const formData = new FormData();

    // Add basic message data
    if (messageData.receiverId)
      formData.append("receiverId", messageData.receiverId);
    if (messageData.groupId) formData.append("groupId", messageData.groupId);
    if (messageData.content) formData.append("content", messageData.content);
    if (messageData.messageType)
      formData.append("messageType", messageData.messageType);

    // Add attachments if any
    if (messageData.attachments && messageData.attachments.length > 0) {
      messageData.attachments.forEach((file) => {
        formData.append("attachments", file);
      });
    }

    const response = await api.post("/messages/send", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending message:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get conversations
export const getConversations = async (page = 1, limit = 20) => {
  try {
    const response = await api.get(
      `/messages/conversations?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching conversations:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get messages for a conversation
export const getConversationMessages = async (
  conversationId,
  page = 1,
  limit = 50
) => {
  try {
    const response = await api.get(
      `/messages/conversation/${conversationId}?page=${page}&limit=${limit}`
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching conversation messages:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Search messages
export const searchMessages = async (query, conversationId = null) => {
  try {
    const params = new URLSearchParams({ query });
    if (conversationId) params.append("conversationId", conversationId);

    const response = await api.get(`/messages/search?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error searching messages:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Pin/Unpin message
export const pinMessage = async (messageId, pin = true) => {
  try {
    const response = await api.patch(`/messages/${messageId}/pin`, { pin });
    return response.data;
  } catch (error) {
    console.error("Error pinning/unpinning message:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Forward message
export const forwardMessage = async (
  messageId,
  { receiverIds = [], groupIds = [] }
) => {
  try {
    const response = await api.post(`/messages/${messageId}/forward`, {
      receiverIds,
      groupIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error forwarding message:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Delete message
export const deleteMessage = async (messageId, deleteType = "onlyForYou") => {
  try {
    const response = await api.delete(`/messages/${messageId}`, {
      data: { deleteType },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting message:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getUserPresence = async (userId) => {
  try {
    const response = await api.get(`/messages/presence/${userId}`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      // Return offline status instead of throwing error
      return { isOnline: false, lastSeen: null };
    }
    console.error("Error fetching user presence:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// =============================================
// GROUP API ROUTES
// =============================================

// Create a new group
export const createGroup = async (groupData) => {
  try {
    const formData = new FormData();

    // Add basic group data
    formData.append("name", groupData.name);
    if (groupData.description)
      formData.append("description", groupData.description);
    if (groupData.groupType) formData.append("groupType", groupData.groupType);
    if (groupData.memberIds)
      formData.append("memberIds", JSON.stringify(groupData.memberIds));

    // Add avatar if provided
    if (groupData.avatar) {
      formData.append("avatar", groupData.avatar);
    }

    const response = await api.post("/groups/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating group:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get user's groups
export const getUserGroups = async () => {
  try {
    const response = await api.get("/groups/my-groups");
    return response.data;
  } catch (error) {
    console.error("Error fetching user groups:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get group details
export const getGroupDetails = async (groupId) => {
  try {
    const response = await api.get(`/groups/${groupId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching group details:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Add members to group
export const addGroupMembers = async (groupId, memberIds) => {
  try {
    const response = await api.post(`/groups/${groupId}/add-members`, {
      memberIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding group members:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Remove member from group
export const removeGroupMember = async (groupId, memberId) => {
  try {
    const response = await api.post(`/groups/${groupId}/remove-member`, {
      memberId,
    });
    return response.data;
  } catch (error) {
    console.error("Error removing group member:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Update group details
export const updateGroup = async (groupId, groupData) => {
  try {
    const formData = new FormData();

    if (groupData.name) formData.append("name", groupData.name);
    if (groupData.description !== undefined)
      formData.append("description", groupData.description);
    if (groupData.avatar) formData.append("avatar", groupData.avatar);

    const response = await api.patch(`/groups/${groupId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating group:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Make member admin
export const makeGroupAdmin = async (groupId, memberId) => {
  try {
    const response = await api.post(`/groups/${groupId}/make-admin`, {
      memberId,
    });
    return response.data;
  } catch (error) {
    console.error("Error making member admin:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Delete group
export const deleteGroup = async (groupId) => {
  try {
    const response = await api.delete(`/groups/${groupId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting group:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Leave group
export const leaveGroup = async (groupId) => {
  try {
    const response = await api.post(`/groups/${groupId}/leave`);
    return response.data;
  } catch (error) {
    console.error("Error leaving group:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Search groups
export const searchGroups = async (query = "", groupType = "all") => {
  try {
    const params = new URLSearchParams();
    if (query) params.append("query", query);
    if (groupType !== "all") params.append("groupType", groupType);

    const response = await api.get(`/groups/search?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error searching groups:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// =============================================
// CONCESSION API ROUTES
// =============================================

// Apply for concession
export const applyConcession = async (concessionData) => {
  try {
    const response = await api.post("/concessions/apply", concessionData);
    return response.data;
  } catch (error) {
    console.error("Error applying concession:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get concession by ID
export const getConcessionById = async (concessionId) => {
  try {
    const response = await api.get(`/concessions/${concessionId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching concession:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get concessions by customer
export const getConcessionsByCustomer = async (customerId, filters = {}) => {
  try {
    const response = await api.get(`/concessions/customer/${customerId}`, {
      params: filters,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching customer concessions:",
      error.response || error
    );
    throw error.response ? error.response.data : error;
  }
};

// Get all concessions (admin only)
export const getAllConcessions = async (filters = {}) => {
  try {
    const response = await api.get("/concessions", { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching all concessions:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Approve concession
export const approveConcession = async (concessionId, approvalData) => {
  try {
    const response = await api.put(
      `/concessions/${concessionId}/approve`,
      approvalData
    );
    return response.data;
  } catch (error) {
    console.error("Error approving concession:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Reject concession
export const rejectConcession = async (concessionId, rejectionData) => {
  try {
    const response = await api.put(
      `/concessions/${concessionId}/reject`,
      rejectionData
    );
    return response.data;
  } catch (error) {
    console.error("Error rejecting concession:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Cancel concession
export const cancelConcession = async (concessionId, cancellationData) => {
  try {
    const response = await api.put(
      `/concessions/${concessionId}/cancel`,
      cancellationData
    );
    return response.data;
  } catch (error) {
    console.error("Error cancelling concession:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Get concession statistics
export const getConcessionStats = async () => {
  try {
    const response = await api.get("/concessions/stats/overview");
    return response.data;
  } catch (error) {
    console.error("Error fetching concession stats:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Fetch plot by ID (for sale_history and previous customer history)
export const getPlotById = async (plotId) => {
  try {
    const response = await api.get(`/societies/plot/${plotId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Entry operations
export const createEntry = async (entryData) => {
  return await api.post("/cash-day-book/entries", entryData);
};

export const getUserEntries = async (params = {}) => {
  const {
    userId,
    page = 1,
    limit = 50,
    type,
    category,
    startDate,
    endDate,
  } = params;
  const url = userId
    ? `/cash-day-book/entries/user/${userId}`
    : "/cash-day-book/entries";
  return await api.get(url, {
    params: { page, limit, type, category, startDate, endDate },
  });
};

export const getAllEntries = async (params = {}) => {
  const { page = 1, limit = 50, designation, startDate, endDate } = params;
  return await api.get("/cash-day-book/entries/all", {
    params: { page, limit, designation, startDate, endDate },
  });
};

export const deleteEntry = async (entryId) => {
  return await api.delete(`/cash-day-book/entries/${entryId}`);
};

// Category operations
export const getUserCategories = async (userId = null) => {
  const url = userId
    ? `/cash-day-book/categories/user/${userId}`
    : "/cash-day-book/categories";
  return await api.get(url);
};

// Summary and statistics
export const getSummary = async (params = {}) => {
  const { userId, startDate, endDate, type } = params;
  const url = userId
    ? `/cash-day-book/summary/user/${userId}`
    : "/cash-day-book/summary";
  return await api.get(url, {
    params: { startDate, endDate, type },
  });
};

// Admin operations
export const closeCashBook = async (userId, endDate = null) => {
  return await api.post(`/cash-day-book/close/${userId}`, { endDate });
};

export const getEmployees = async () => {
  return await api.get("/cash-day-book/employees");
};

// Utility functions for date handling
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const getDateRange = (period) => {
  const today = new Date();
  const startDate = new Date();

  switch (period) {
    case "today":
      startDate.setHours(0, 0, 0, 0);
      return {
        startDate: startDate.toISOString().split("T")[0],
        endDate: today.toISOString().split("T")[0],
      };

    case "week":
      startDate.setDate(today.getDate() - 7);
      return {
        startDate: startDate.toISOString().split("T")[0],
        endDate: today.toISOString().split("T")[0],
      };

    case "month":
      startDate.setMonth(today.getMonth() - 1);
      return {
        startDate: startDate.toISOString().split("T")[0],
        endDate: today.toISOString().split("T")[0],
      };

    case "year":
      startDate.setFullYear(today.getFullYear() - 1);
      return {
        startDate: startDate.toISOString().split("T")[0],
        endDate: today.toISOString().split("T")[0],
      };

    default:
      return { startDate: null, endDate: null };
  }
};

export const exportToCSV = (data, filename) => {
  if (!data.length) return;

  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(","),
    ...data.map((row) =>
      headers.map((header) => `"${row[header] || ""}"`).join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Create an object with all functions for easier importing
export const cashDayBookApi = {
  createEntry,
  getUserEntries,
  getAllEntries,
  deleteEntry,
  getUserCategories,
  getSummary,
  closeCashBook,
  getEmployees,
};

// Create dateUtils object
export const dateUtils = {
  formatDate,
  formatCurrency,
  getDateRange,
  exportToCSV,
};

// Default export for backward compatibility
const cashDayBookService = {
  ...cashDayBookApi,
  ...dateUtils,
};

// Agreement API
export const getAllAgreements = async (societyId = null) => {
  try {
    const params = societyId ? { societyId } : {};
    const response = await api.get("/agreement/agreements", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching agreements:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const getOverdueAgreements = async (societyId = null) => {
  try {
    const params = societyId ? { societyId } : {};
    const response = await api.get("/agreement/agreements/overdue", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching overdue agreements:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

export const createAgreement = async (agreementData) => {
  try {
    const response = await api.post("/agreement/agreements", agreementData);
    return response.data;
  } catch (error) {
    console.error("Error creating agreement:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};

// Dealer Commission API
export const getDealersWithCommissions = async (societyId = null) => {
  try {
    const params = societyId ? { society_id: societyId } : {};
    const response = await api.get("/booking/dealers/commissions", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching dealers with commissions:", error.response || error);
    throw error.response ? error.response.data : error;
  }
};


// Follow-up API calls
export const createFollowUp = async (followUpData) => {
  try {
    const response = await api.post("/followups", followUpData);
    return response.data;
  } catch (error) {
    console.error("Error creating follow-up:", error);
    throw error;
  }
};

export const fetchFollowUpsByPlot = async (plotId) => {
  try {
    const response = await api.get(`/followups/plot/${plotId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching follow-ups:", error);
    throw error;
  }
};

export const fetchPendingFollowUps = async (limit = 10, societyId = null) => {
  try {
    const params = { limit };
    if (societyId) {
      params.societyId = societyId;
    }
    const response = await api.get(`/followups/pending`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching pending follow-ups:", error);
    throw error;
  }
};

export const updateFollowUpStatus = async (id, status) => {
  try {
    const response = await api.patch(`/followups/${id}/status`, { status });
    return response.data;
  } catch (error) {
    console.error("Error updating follow-up status:", error);
    throw error;
  }
};

export const deleteFollowUp = async (id) => {
  try {
    const response = await api.delete(`/followups/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting follow-up:", error);
    throw error;
  }
};

// Chat API
export const sendChatMessage = async (chatData) => {
  try {
    const response = await api.post("/chat", chatData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const getChatHistory = async (sessionId) => {
  try {
    const response = await api.get(`/chat/${sessionId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const clearChatHistory = async (sessionId) => {
  try {
    const response = await api.delete(`/chat/${sessionId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export default api;
